<template>
  <button
    v-if="recipeId"
    @click="performToggleSelection"
    class="btn btn-selection"
    :disabled="selectionInProgress"
    :title="
      isSelected ? 'Убрать из списка готовки' : 'Добавить в список готовки'
    "
  >
    <i
      :class="
        isSelected ? 'bi bi-cart-check-fill text-success' : 'bi bi-cart-plus'
      "
    ></i>
  </button>
</template>

<script>
export default {
  name: "RecipeSelection",
  props: {
    recipeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectionInProgress: false,
    };
  },
  computed: {
    isSelected() {
      // The recipeId prop can be a string, but the global state stores numbers.
      // Ensure type consistency for the `includes` check.
      return this.$globalState.selectedRecipes.includes(Number(this.recipeId));
    },
  },
  methods: {
    async performToggleSelection() {
      if (!this.recipeId || this.selectionInProgress) return;
      if (!this.$globalState.apiUrl) {
        console.error(
          "RecipeSelection: API URL not available, cannot toggle selection."
        );
        return;
      }

      this.selectionInProgress = true;
      const recipeIdNum = Number(this.recipeId);
      const command = this.isSelected
        ? `cookinglist.remove/${this.recipeId}`
        : `cookinglist.add/${this.recipeId}`;

      try {
        await this.sendCmd(command);
        // If command is successful, update the global state.
        // This is not an optimistic update; it happens after server confirmation.
        if (this.isSelected) {
          // It was selected, so we removed it. Now update the global state.
          const index = this.$globalState.selectedRecipes.indexOf(recipeIdNum);
          if (index > -1) this.$globalState.selectedRecipes.splice(index, 1);
        } else {
          // It was not selected, so we added it.
          this.$globalState.selectedRecipes.push(recipeIdNum);
        }
        this.$emit("selection-changed", this.$globalState.selectedRecipes);
      } catch (error) {
        console.error("RecipeSelection: Error toggling selection:", error);
        // Optionally show a toast/error message to the user
      } finally {
        this.selectionInProgress = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-selection {
  background: none;
  border: none;
  margin-bottom: 12px;
  font-size: 1.5rem;
  padding: 0;
}
</style>
